<!--<div class="form-inline">
  <div class="form-group">
    <label><h3>{{title}}</h3></label>
  </div>
  <div class="form-group">
    <div class="col-lg-12">
      <input class="form-control" placeholder="Enter any text to filter" (paste)="getPasteData($event)" (keyup)="getEachChar($event.target.value)" type="text" [(ngModel)]="listFilter" />
      <button class="form-control" (click)="clearFilter()" *ngIf="listFilter" >X</button>
    </div>
  </div>
  <div class="form-group">
    <div *ngIf='listFilter'>
      <div class="h3 text-muted">Filter by: {{listFilter}}</div>
    </div>
  </div>
</div>-->
<div class="form-inline" *ngIf="hideTitle === 0">
  <div class="form-group">
    <h3><label>{{title}}</label></h3>
  </div>
  <div class="form-group">
    <div class="col-lg-12 col-md-12 col-xs-12">
      <input class="form-control svis-clear" placeholder="Enter any text to filter" (paste)="getPasteData($event)" (keyup)="getEachChar($event.target.value)"
             type="search" [(ngModel)]="listFilter" />
      <button class="form-control" (click)="clearFilter()" *ngIf="listFilter">X</button>
    </div>
  </div>
  <div class="form-group">
    <div *ngIf='listFilter'>
      <div class="h3 text-muted">Filter by: {{listFilter}}</div>
    </div>
  </div>
</div>

<div class="user-search margin-top-0px" *ngIf="hideTitle === 1">
  <div class="row row-margin-zero">
    <div class="col-md-12 padding-lr-0px ">
      <input type="search" class="form-control svis-clear padding-bottom-2px " placeholder="Search..."
             (paste)="getPasteData($event)" (keyup)="getEachChar($event.target.value)" [(ngModel)]="listFilter" >
    </div>
   
  </div>
</div>

